/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerResetCustomerMigrationMutationRequest, TransfersControllerResetCustomerMigrationMutationResponse, TransfersControllerResetCustomerMigration400, TransfersControllerResetCustomerMigration401, TransfersControllerResetCustomerMigration403, TransfersControllerResetCustomerMigration404 } from "../../models/transfersController/TransfersControllerResetCustomerMigration";

function getTransfersControllerResetCustomerMigrationUrl() {
  const res = { method: 'POST', url: `/api/v1/transfers/reset-customer` as const }  
  return res
}

/**
 * @summary Reset a customer's migration (admin/test utility)
 * {@link /api/v1/transfers/reset-customer}
 */
export async function transfersControllerResetCustomerMigration(data?: TransfersControllerResetCustomerMigrationMutationRequest, config: Partial<RequestConfig<TransfersControllerResetCustomerMigrationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransfersControllerResetCustomerMigrationMutationResponse, ResponseErrorConfig<TransfersControllerResetCustomerMigration400 | TransfersControllerResetCustomerMigration401 | TransfersControllerResetCustomerMigration403 | TransfersControllerResetCustomerMigration404>, TransfersControllerResetCustomerMigrationMutationRequest>({ method : "POST", url : getTransfersControllerResetCustomerMigrationUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}